import { render, staticRenderFns } from "./ReservedCollectionButtonToggle.vue?vue&type=template&id=2f557e30&"
import script from "./ReservedCollectionButtonToggle.vue?vue&type=script&lang=ts&"
export * from "./ReservedCollectionButtonToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports